<template>
    <div class="relative">
        <p v-if="qty > 0" class="absolute" :class="fontclass" :style="{color: color}">
            {{ qty }}
        </p>
        <svg v-if="qty > 0" width="37" height="24" viewBox="0 0 37 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.26 0C22.3558 0 18.2989 3.69364 17.6313 8.47977H14.3447V0H12.6329V8.47977H0L5.46912 24H21.4999L23.3058 18.8757C24.5212 19.422 25.8563 19.7341 27.2686 19.7341C32.635 19.7341 37.0086 15.3121 37.0086 9.86705C37.0086 4.42197 32.635 0 27.26 0ZM20.2845 22.2659H6.67592L2.43072 10.2139H17.5371C17.6484 13.4566 19.3003 16.3006 21.7823 18.0173L20.2845 22.2572V22.2659ZM27.26 18C26.0532 18 24.9063 17.7225 23.8792 17.237C23.3486 16.9855 22.8436 16.6734 22.39 16.3179C20.567 14.896 19.3602 12.7023 19.2575 10.2225C19.2575 10.1098 19.2403 9.98844 19.2403 9.87572C19.2403 9.39884 19.2917 8.93931 19.3687 8.48844C20.0192 4.66474 23.3144 1.74277 27.2686 1.74277C31.6935 1.74277 35.2968 5.39306 35.2968 9.87572C35.2968 14.3584 31.6935 18.0087 27.2686 18.0087L27.26 18Z" :fill="color"/> 
        </svg>
        <svg v-else width="33" height="28" viewBox="0 0 33 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5302 10.4803V2H17.7942V10.4803H5L10.5378 26H26.7779L32.3157 10.4803H19.5215H19.5302ZM25.5541 24.264H11.7617L7.4651 12.2163H29.8593L25.5541 24.264Z" :fill="color"/>        
        </svg>        
    </div>


</template>

<script setup>
    const props = defineProps({
        color: {
            type: String,
            required: false,
            default: '#1C1C1C'
        },
        qty: {
            type: Number,
            required: true
        }
    });
    import { computed } from 'vue';

    const fontclass = computed(() => {
        if( props.qty > 9)
            return 'text-xs tiny';

        return 'small';
    });


</script>
<style scoped>
  p {
    top: -6%;
    right: 14%;
  }

  p.tiny{
    top: 8%;
    right: 9%;
  }
</style>
